'use strict';

var buildMathAliases = require('../internal/buildMathAliases');

buildMathAliases();